import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

// Connects to data-controller="tags-input"
export default class extends Controller {
  static targets = ["input"];

  connect() {
    if (this.choices) return;

    // Initialize Choices.js on the input field.
    this.choices = new Choices(this.inputTarget, {
      removeItemButton: true,
      duplicateItemsAllowed: false,
      searchEnabled: true,
      placeholderValue: "Type to search tags...",
      noResultsText: "No matching tags found",
      noChoicesText: "No choices to choose from",
      addItems: true,
      addChoices: true,
      classNames: {
        containerInner: ["flex", "flex-wrap", "gap-0", "form-input", "rounded-md", "text-sm", "w-full"],
        itemSelectable: ["badge", "badge-secondary"],
        item: ["badge", "badge-primary", "mr-1", "mb-1"],
      },
    });
    if (this.choices.input && this.choices.input.element) {
      this.choices.input.element.addEventListener("input", (event) => {
        const query = event.target.value.trim();
        if (query.length > 0) {
          this.searchTags(query);
        }
      });
    }
  }

  disconnect() {
    if (this.choices) {
      this.choices.destroy();
      this.choices = null;
    }
  }

  // Fetch matching tags from the backend based on the query and update the choices
  searchTags(query) {
    fetch(`/tags?query=${encodeURIComponent(query)}`)
      .then((response) => response.json())
      .then((data) => {
        // Format data for Choices.js: an array of objects with value and label keys
        const choicesData = data.map((tag) => ({
          value: tag,
          label: tag,
          selected: false,
          disabled: false,
        }));
        // Update Choices with the new list. The fourth parameter forces a re-render.
        this.choices.setChoices(choicesData, "value", "label", true);
      })
      .catch((error) => console.error("Error fetching tags:", error));
  }
}
